import { useState, useMemo, useEffect } from 'react';
import globalConfig from 'react-global-configuration';

export default function useAppliedStockAssets(
{
  appliedExtras: appliedExtrasJSON,
  requestedExtras: requestedExtrasJSON



},
outputIds,
organisationId,
getStockAssetRecords)
{
  const [loading, setLoading] = useState(false);
  const [appliedStockAssets, setAppliedStockAssets] = useState([]);

  const { stockAssets: stockAssetsDisabled } = globalConfig.get('HIDE_FEATURES') || {};

  const utilizedAssets = useMemo(() => {
    const [appliedStock, requestedStock] = [appliedExtrasJSON, requestedExtrasJSON].map((j) =>
    JSON.parse(j || '{}').STOCK_ASSETS
    );
    if (!(appliedStock || requestedStock)) return {};

    const assetList = outputIds.length && appliedStock ?
    appliedStock.filter(({ outputs }) => !outputs || outputs.find((id) => outputIds.includes(id))) :
    requestedStock;

    return assetList.reduce((acc, { value, ...asset }) => ({
      ...acc,
      [value]: {
        value,
        ...asset
      }
    }), {});
  }, [appliedExtrasJSON, requestedExtrasJSON, outputIds]);

  useEffect(() => {
    const utilizedAssetIds = Object.keys(utilizedAssets);

    if (stockAssetsDisabled || !utilizedAssetIds.length) {
      setLoading(false);
      setAppliedStockAssets([]);
    }

    if (loading) return;

    setLoading(true);

    (async () => {
      const {
        data: { stockAssetRecords: records } = {},
        error
      } = await getStockAssetRecords({
        assetIds: utilizedAssetIds,
        organisationId
      });

      if (!records || error) {
        setLoading(false);
        return;
      }

      const augmentedList = records.
      map(({ assetId, purchased, firstUseOutputId, ...asset }) => ({
        ...utilizedAssets[assetId],
        ...asset,
        assetId,
        alreadyLicensed: purchased && !outputIds.includes(firstUseOutputId)
      }));

      setAppliedStockAssets(augmentedList);
      setLoading(false);
    })();
  }, [utilizedAssets]);

  return {
    loading,
    appliedStockAssets,
    stockAssetsEnabled: !stockAssetsDisabled
  };
}